export default "__VITE_ASSET__CxCENg$0__"